import * as Actions from 'store/actions/app/account_payment_means.actions'
import { toggleIdInArray } from 'utils/toggle-id-in-array'

const initialState = {
  loading_account_payment_means: false,
  account_payment_means: [],

  saving_account_payment_mean_codes: [],
  saved_account_payment_mean_codes: [],

  deleting_account_payment_mean_codes: [],
  deleted_account_payment_mean_codes: [],
}

const accountPaymentMeansReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_ACCOUNT_PAYMENT_MEANS: {
      return {
        ...state,
        loading_account_payment_means: action.payload.loading ?? state.loading_account_payment_means,
        account_payment_means: action.payload.data ?? state.account_payment_means,
      }
    }
    case Actions.SAVE_ACCOUNT_PAYMENT_MEAN: {
      return {
        ...state,
        saving_account_payment_mean_codes: toggleIdInArray(state.saving_account_payment_mean_codes, action.payload.saving_code),
        saved_account_payment_mean_codes: toggleIdInArray(state.saved_account_payment_mean_codes, action.payload.saved_code),
      }
    }
    case Actions.SAVE_ACCOUNT_PAYMENT_MEAN: {
      return {
        ...state,
        deleting_account_payment_mean_codes: toggleIdInArray(state.deleting_account_payment_mean_codes, action.payload.deleting_code),
        deleted_account_payment_mean_codes: toggleIdInArray(state.deleted_account_payment_mean_codes, action.payload.deleted_code),
      }
    }
    default: {
      return state
    }
  }
}

export default accountPaymentMeansReducer
